const Terms = () => {
  return (
    <div className="page-container fade-in">
      <div className="page-header-bg">
        <div className="page-hero-box">
          <h1>Conditions d'Utilisation</h1>
          <div className="breadcrumbs">Accueil &gt; Conditions d'Utilisation</div>
        </div>
      </div>

      <div className="container page-layout-grid">
        <div className="page-content-wrapper legal-content">
          <p className="last-updated">Dernière mise à jour : Mars 2026</p>

          <h2>1. Acceptation des conditions</h2>
          <p>
            En accédant et en utilisant le site web de Akaap Network, vous acceptez d'être lié par les présentes conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre site.
          </p>

          <h2>2. Description du service</h2>
          <p>
            Akaap Network fournit des services de développement web, formation, outsourcing international, rédaction de contenu, traduction, transcription, sous-titrage, marketing digital, et assistance pour les paiements internationaux (PayPal, Payoneer). Nos services s'adressent aux particuliers et aux entreprises souhaitant développer leur présence numérique.
          </p>

          <h2>3. Propriété intellectuelle</h2>
          <p>
            Tout le contenu présent sur ce site web, incluant mais ne se limitant pas aux textes, graphiques, logos, images, clips audio, clips vidéo, et logiciels, est la propriété de Akaap Network ou de ses fournisseurs de contenu et est protégé par les lois internationales sur le droit d'auteur.
          </p>
          <p>
            Vous ne pouvez pas reproduire, distribuer, modifier, afficher, vendre, ou exploiter de quelque manière que ce soit tout contenu de ce site sans notre autorisation écrite préalable.
          </p>

          <h2>4. Services et tarification</h2>
          <p>
            Les prix affichés sur notre site pour nos services sont indicatifs et peuvent varier en fonction de la complexité du projet. Un devis personnalisé sera fourni après discussion des besoins spécifiques du client.
          </p>
          <p>
            La création de site web commence à partir de 6 500 FCFA. Les autres services sont facturés selon un accord préalable entre les parties.
          </p>

          <h2>5. Engagement du client</h2>
          <p>
            En engageant nos services, vous vous engagez à :
          </p>
          <ul>
            <li>Fournir des informations exactes et complètes nécessaires à l'exécution du service</li>
            <li>Payer les services согласованы selon les modalités convenues</li>
            <li>Répondre aux demandes de feedback dans un délai raisonnable</li>
            <li>Respecter les délais de validation des livrables</li>
          </ul>

          <h2>6. Livraison et délais</h2>
          <p>
            Les délais de livraison sont estimés lors de la commande et peuvent varier en fonction de la nature du projet. Nous nous engageons à informer le client de tout retard significatif dans l'avancement des travaux.
          </p>

          <h2>7. Droit de rétractation</h2>
          <p>
            Étant donné la nature numérique de nos services, aucun remboursement ne sera effectué une fois le travail livré et validé par le client. Nous encourageons une communication claire et des jalons de validation tout au long du projet.
          </p>

          <h2>8. Confidentialité</h2>
          <p>
            Akaap Network s'engage à ne pas divulguer les informations confidentielles de ses clients à des tiers. Toutes les informations partagées dans le cadre de nos services sont traitées avec la plus stricte confidentialité.
          </p>

          <h2>9. Limitation de responsabilité</h2>
          <p>
            Akaap Network ne peut être tenu responsable des dommages indirects, accessoires, spéciaux ou consécutifs découlant de l'utilisation de nos services ou de notre site web.
          </p>
          <p>
            Nous ne garantissons pas que notre site sera exempt d'erreurs ou que l'accès sera ininterrompu. L'utilisateur reconnaît utiliser notre site à ses propres risques.
          </p>

          <h2>10. Liens vers des sites tiers</h2>
          <p>
            Notre site peut contenir des liens vers des sites web de tiers. Ces liens sont fournis pour votre commodité. Nous n'avons aucun contrôle sur le contenu de ces sites et déclinons toute responsabilité quant à leur contenu ou leurs pratiques de confidentialité.
          </p>

          <h2>11. Modifications des conditions</h2>
          <p>
            Nous nous réservons le droit de modifier ces conditions d'utilisation à tout moment. Les modifications entreront en vigueur dès leur publication sur le site. Il est de votre responsabilité de consulter régulièrement cette page pour prendre connaissance des éventuelles modifications.
          </p>

          <h2>12. Droit applicable</h2>
          <p>
            Les présentes conditions d'utilisation sont régies par les lois de la République du Cameroun. Tout litige relatif à l'utilisation de nos services sera soumis à la jurisdiction exclusive des tribunaux camerounais.
          </p>

          <h2>13. Contact</h2>
          <p>
            Pour toute question concernant ces conditions d'utilisation, veuillez nous contacter :
          </p>
          <ul className="contact-list">
            <li><strong>Email :</strong> akaapnetwork@gmail.com</li>
            <li><strong>Téléphone :</strong> +237 699 47 20 98</li>
            <li><strong>Adresse :</strong> Biyem-Assi, Yaoundé, Cameroun</li>
          </ul>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-widget sidebar-cta-widget">
            <h4 className="widget-title">Besoin d'aide ?</h4>
            <p>Notre équipe est prête à vous accompagner dans votre projet digital.</p>
            <a href="/contact" className="btn-primary btn-primary-sm">
              Contactez-nous
            </a>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Terms;
